const DocumentStatus = {
  New: "new",
  Scanned: "scanned",
  Indexed: "indexed",
};

export default DocumentStatus;
